var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"deep-badge deep-badge--outline"},[_c('span',{staticClass:"deep-badge__ico"},[_vm._v("★")]),_c('span',{staticClass:"deep-badge__cn"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }